import ActionTypes from '../../../constants/ActionTypes';
import {commonReducers} from '@gisatcz/ptr-state';

const INITIAL_STATE = {
	byKey: {},
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case ActionTypes.UNHAB.DATASET_SETS.ADD:
			return commonReducers.add(state, action);
		case ActionTypes.UNHAB.DATASET_SETS.SET_ACTIVE_KEY:
			return commonReducers.setActive(state, action);
		default:
			return state;
	}
};
